export default "__VITE_ASSET__C_c6ZLmE__"